import { useMemo } from 'react';
import classNames from 'classnames';
import { BuscadorNotariosForm, BuscadorEscriturasForm, Section } from '@/components';
import type { BuscadorEscriturasFormValues } from '../BuscadorEscriturasForm/config';
import type { BuscadorNotariosFormValues } from '../BuscadorNotariosForm/config';

type BuscadoresProps = {
	readonly className?: string;
};

const classNameComponent = 'c-cnm-buscadores';

export const Buscadores = ({ className }: BuscadoresProps) => {
	const wrapperClassName = useMemo(() => classNames(classNameComponent, className), [className]);

	const getEscrituras = (values: BuscadorEscriturasFormValues) => {
		console.log(' Peticion escrituras');
	};

	const getNotarios = (values: BuscadorNotariosFormValues) => {
		console.log(' Peticion notarios');
	};

	return (
		<Section className={wrapperClassName}>
			<div className="o-container">
				<div className={`${classNameComponent}__grid`}>
					<BuscadorEscriturasForm onSubmitSuccess={getEscrituras} />
					<BuscadorNotariosForm onSubmitSuccess={getNotarios} />
				</div>
			</div>
		</Section>
	);
};
